import { paletteSheetVCuttoff, generatePaletteGLSLMapping } from "../../../generated/generatePaletteShaderSnippets";
import { Colors } from "../../../palettes/colorPalette";

export default `
precision highp float;

varying vec2 vUv;

uniform sampler2D sprites;
uniform vec3 antigenColor;
uniform sampler2D heightmap;

void main() {

	vec4 color = texture2D(sprites, vUv);

	//This was to clean up random mistakes in input sprites, but I disabled it, don't remember why
	//if(color.a < 0.9) color.a = 0.0;

	vec4 result;
	if(vUv.y > float(${paletteSheetVCuttoff})) {
		result = color;
	}
	else {
		int key = int(color.r * 255.0);
		float gradient = color.g;

		bool match = false;
		vec4 colorStart = vec4(1.0, 0.0, 0.0, 0.0);
		vec4 colorEnd = vec4(0.0, 0.0, 1.0, 0.0);
		${generatePaletteGLSLMapping(Colors)}

		//Some values may fall between pixels and not match a key, so we just make them transparent
		if(!match) {
			color.a = 0.0;
		}

		result = mix(colorStart, colorEnd, gradient);
	}

	gl_FragColor = vec4(result.xyz, color.a);
}
`